import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CustomCard from "./CustomCard"; // Adjust the import path if necessary
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";

const ChallengeRulesSection = ({
  rules,
  currentRule,
  setCurrentRule,
  handleAddRule,
  handleDeleteRule,
  theme,
  disabled, // New prop to determine if the form is disabled
}) => {
  return (
    <CustomCard title="Challenge Rules">
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="body1"
          sx={{ mb: 2, color: "white", fontFamily: "basic-sans" }}
        >
          Create the rules for your Challenge. For example:
        </Typography>
        <Typography
          variant="body2"
          sx={{ mb: 1, color: "white", fontFamily: "basic-sans" }}
        >
          1. Video must be 10 seconds long. <br />
          2. Participants must be 18 or over. <br />
          3. Must have three or more participants per video.
        </Typography>
      </Box>

      {/* Rule Input Field */}
      <input
        type="text"
        id="ruleInput"
        value={currentRule}
        onChange={(e) => setCurrentRule(e.target.value)}
        disabled={disabled} // Disable input field if disabled is true
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          fontFamily: "basic-sans",
          backgroundColor: disabled ? "#f0f0f0" : "white", // Change background when disabled
        }}
      />

      {/* Conditionally render the Add Rule Button */}
      {!disabled && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddRule}
          sx={{
            backgroundColor: theme.colors.blue,
            borderRadius: "50px",
            textTransform: "none",
            color: "white",
            "&:hover": { backgroundColor: theme.colors.green },
            padding: "4px 16px 4px 4px",
            mt: 4,
          }}
        >
          <ControlPointIcon
            sx={{
              color: "white",
              fontSize: "2em",
              minWidth: "1.5em",
              minHeight: "1.5em",
              marginRight: "8px",
            }}
          />
          Add Another Rule
        </Button>
      )}

      {/* List of Rules */}
      {rules.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: "bold",
              mb: 1,
              color: "white",
              fontFamily: "basic-sans",
            }}
          >
            Rules:
          </Typography>
          <ol>
            {rules.map((rule, index) => (
              <li key={index} style={{ display: "flex", alignItems: "center" }}>
                {/* Conditionally render the Delete Button */}
                {!disabled && (
                  <IconButton
                    onClick={() => handleDeleteRule(index)}
                    sx={{ color: theme.colors.red }}
                  >
                    <RemoveCircleOutlineOutlinedIcon />
                  </IconButton>
                )}
                <Typography
                  variant="body2"
                  sx={{ color: "white", fontFamily: "basic-sans", flexGrow: 1 }}
                >
                  {rule}
                </Typography>
              </li>
            ))}
          </ol>
        </Box>
      )}
    </CustomCard>
  );
};

export default ChallengeRulesSection;
